import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
function LandAnalysisD(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);

  const [structureType, SetstructureType] = React.useState("Per Home");
  React.useEffect(() => {

    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.value == "") {
      //  setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.id == 45) {
      SetStyle("form-control construction leftTop");
    }

    if (props.id == 243) {
      SetStyle("form-control construction leftTop");
    }
    if (props.id == 246) {
      SetStyle("form-control construction ");
    }
    if (props.id == 245 || props.id == 175 || props.id == 248 || props.id == 47) {
      SetStyle("form-control construction ");
    }
    if (props.id == 244) {
      SetStyle("form-control construction RightTop ");
    }
    if (props.id == 247) {
      SetStyle("form-control construction leftBottom");
    }
    if (props.id == 47) {
      SetStyle("form-control construction RightBottom ");
    }
    if (props.id == 226) {
      SetStyle("form-control construction  leftBottom");
    }
    if (props.id == 280) {
      SetStyle("form-control construction RightBottom  Prowidth2");
    }
    if (props.id == 181) {
      SetStyle("form-control  Prowidth2 RightTop");
    }
    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);

    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);
  }, []);




  const onChange = (e) => {

    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";


    setchecked(e.target.checked);
    setchecked1(e.target.checked);

    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    if (checkid.includes("148")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 47 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 247 && item.structureType == structuretype).ischecked = false;
      // props.setData({...props.wholeEl,...props.wholeEl.ischecked,ischecked : true,value : value})  
      document.getElementById(structuretype + "-148").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-247").style.background = "#f7fafd";
      document.getElementById(structuretype + "-47").style.background = "#f7fafd";
    }
    if (checkid.includes("45")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 246 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).value = 0;
      props.object["Land Analysis"].find((item) => item.ParameterId == 246 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-45").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-246").style.background = "#f7fafd";
      document.getElementById(structuretype + "-181").style.background = "#f7fafd";
      document.getElementById(structuretype + "-246").value = 0;
      document.getElementById(structuretype + "-181").value = 0;
    }
    if (checkid.includes("47")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 148 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 247 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 247 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-47").style.background = "#e7f0fa";
    }
    if (checkid.includes("181")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 246 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).value = 0;
      props.object["Land Analysis"].find((item) => item.ParameterId == 246 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-181").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-246").style.background = "#f7fafd";
      document.getElementById(structuretype + "-45").style.background = "#f7fafd";
      document.getElementById(structuretype + "-246").value = 0;
      document.getElementById(structuretype + "-45").value = 0;

    }
    if (checkid.includes("247")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 47 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 148 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-247").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-148").style.background = "#f7fafd";
      document.getElementById(structuretype + "-47").style.background = "#f7fafd";

    }
    if (checkid.includes("226")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 248 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 280 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 248 && item.structureType == structuretype).value = 0;
      props.object["Land Analysis"].find((item) => item.ParameterId == 280 && item.structureType == structuretype).value = 0;

      document.getElementById(structuretype + "-226").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-248").style.background = "#f7fafd";
      document.getElementById(structuretype + "-280").style.background = "#f7fafd";
      document.getElementById(structuretype + "-248").value = 0;
      document.getElementById(structuretype + "-280").value = 0;
    }
    if (checkid.includes("248")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 226 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 280 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 226 && item.structureType == structuretype).value = 0;
      props.object["Land Analysis"].find((item) => item.ParameterId == 280 && item.structureType == structuretype).value = 0;

      document.getElementById(structuretype + "-248").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-226").style.background = "#f7fafd";
      document.getElementById(structuretype + "-280").style.background = "#f7fafd";
      document.getElementById(structuretype + "-226").value = 0;
      document.getElementById(structuretype + "-280").value = 0;
    }
    if (checkid.includes("280")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 226 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 248 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 226 && item.structureType == structuretype).value = 0;
      props.object["Land Analysis"].find((item) => item.ParameterId == 248 && item.structureType == structuretype).value = 0;

      document.getElementById(structuretype + "-280").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-226").style.background = "#f7fafd";
      document.getElementById(structuretype + "-248").style.background = "#f7fafd";
      document.getElementById(structuretype + "-226").value = 0;
      document.getElementById(structuretype + "-248").value = 0;
    }
    if (checkid.includes("246")) {

      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).value = 0;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).value = 0;

      document.getElementById(structuretype + "-246").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-45").style.background = "#f7fafd";
      document.getElementById(structuretype + "-181").style.background = "#f7fafd";
      document.getElementById(structuretype + "-45").value = 0;
      document.getElementById(structuretype + "-181").value = 0;

    }
    // props.setData({...props.wholeEl,value : e.target.value,ischecked:true})

    props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = e.target.value;
    document.getElementById(structuretype + "-All-Def").click();
    // var formID=0;
    // let newArr =[];
    //   newArr=({
    //    ParameterId: parameterid,ParameterName: props.name,ParameterTypeId:props.ParameterTypeId,value: e.target.value,
    //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: 0,perprojectvalue: 0, ParamOrder: 0,
    //  });

    //  var name=Cookies.get('username');
    //  let params = {
    //   username: name,
    //   Stage:"P",
    //   formId: formID,
    //   userType:"AutoSave",
    //   parameters: []
    //  };
    //  params.StructureTypes=[{
    //   StructureType: structuretype,
    //   Calculations: [newArr],}
    //  ]
    //  params = JSON.stringify({
    //    Body: params,
    //  });
    //  console.log(params)
    //  return axios
    //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
    //      headers: {
    //        "Content-Type": "application/json",
    //        Accept: "application/json",
    //      },
    //      crossorigin: true,
    //    })
    //    .then((res) => {
    //    // setLoading(false);
    //    console.log("here")
    //      return res.data;
    //    })
    //    .catch((e) => {
    //    // setLoading(false);
    //      alert(e.message);
    //    });  
  };

  const onChange1 = (e) => {


    setchecked(e.target.checked);
    setchecked1(e.target.checked);
    //props.setData({...props.wholeEl,...props.wholeEl.ischecked,ischecked : e.target.checked,value : value})


  };






  if (props.id == 227) {
    return (
      <>
        <div class="row" style={{ marginTop: "5%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "91.5%" }}>
          <div class="col-md-6" ></div>
          <div class="col-md-3 col-7" style={{ marginTop: "3%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop" style={{ marginTop: "5%" }}><u>{props.name.split('Per')[0]} </u>
              </label>



            </div>
          </div>

          <div class="col-md-3 col-5" style={{ marginTop: "3%" }}>
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control construction"
                style={{ borderRadius: "5px", fontWeight: "550" }}
              />
            </div>
          </div>
        </div>
        <div class="row" style={{ width: "92%", marginTop: "2%" }}>

          <p style={{ width: "98%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>Estimated Value - Building Cost - Total Sales Cost - Desired Profit = Land Value

          </p>
          <p style={{ width: "98%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>Land Value + Closing Cost = Total Land Cost

          </p>
        </div>
      </>
    );
  }

  if (props.id == 243 || props.id == 147 || props.id == 244) {
    if (props.id == 243) {
      return (

        <>
          <div class="col-md-12 input-box1 ">
            <div class="row" style={{ width: "107%" }}>
              <div class="col-md-3"></div>
              <div class="col-md-2 col-3"><label class="d-block text-center">Per sqft </label></div>
              <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-2 col-3">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ borderBottom: "2px solid" }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ borderBottom: "2px solid" }}
                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 226 || props.id == 248) {
    if (props.id == 226) {

      if (props.ischecked == true) {
        return (

          <>
            <div class="col-md-5" >
              <div class="from   justify-content-between  align-items-center ">
                <label class="mr-1 mtop"> Closing Cost


                </label>



              </div>
            </div>
            <div class="col-md-3 col" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}
                    style={{ backgroundColor: "#e7f0fa" }}
                  />
                </div>
              </div>
            </div>
          </>
        );
      } else {
        if (props.ischecked == true) {
          return (

            <>
              <div class="col-md-5" >
                <div class="from   justify-content-between  align-items-center ">
                  <label class="mr-1 mtop"> Closing Cost

                  </label>



                </div>
              </div>
              <div class="col-md-3 col" >
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}
                      style={{ backgroundColor: "#e7f0fa" }}
                    />
                  </div>
                </div>
              </div>
            </>
          );
        }
        else {

          return (

            <>
              <div class="col-md-5" >
                <div class="from   justify-content-between  align-items-center ">
                  <label class="mr-1 mtop">Closing Cost


                  </label>



                </div>
              </div>
              <div class="col-md-3 col" >
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}

                    />
                  </div>
                </div>
              </div>
            </>
          );
        }

      }
    }
    else {
      return (

        <>


          <div class="col-md-2 col-3" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 247 || props.id == 148 || props.id == 47) {
    if (props.id == 247) {

      return (

        <>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop"><u>{props.name.split('Per')[0]}</u>
              </label>



            </div>
          </div>

          <div class="col-md-2 col-3">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 47) {

      return (

        <>
          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  else if (props.id == 170 || props.id == 245 || props.id == 172 || props.id == 175 || props.id == 45 || props.id == 246 || props.id == 181 || props.id == 280) {

    if (props.id == 170 || props.id == 172 || props.id == 114 || props.id == 113) {

      return (
        <>
          <div class="col-md-5">
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop">- {props.name.split('Per')[0]}
              </label>
            </div>
          </div>
          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input

                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly

                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 45) {
      if (props.ischecked == true) {
        return (
          <>
            <div class="col-md-5">
              <div class="from   justify-content-between  align-items-center ">
                <label class="mr-1 mtop"> {props.name.split('Per')[0]}


                </label>
              </div>
            </div>
            <div class="col-md-3 col">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input

                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}

                    class={IsStyle}
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>
            <div class="col-md-5">
              <div class="from   justify-content-between  align-items-center ">
                <label class="mr-1 mtop"> {props.name.split('Per')[0]}


                </label>
              </div>
            </div>
            <div class="col-md-3 col">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input

                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}


                    class={IsStyle}
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
    else if (props.id == 246) {
      if (props.ischecked == true) {
        return (
          <>

            <div class="col-md-2 col-3">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>

            <div class="col-md-2 col-3">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );

      }
    }
    else if (props.id == 280) {
      if (props.ischecked == true) {
        return (
          <>

            <div class="col-md-1 col-2" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>

            <div class="col-md-1 col-2" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    // style={{padding:"0rem !important"}}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
    else if (props.id == 181) {
      if (props.ischecked == true) {
        return (
          <>

            <div class="col-md-1 col-2">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>

            <div class="col-md-1 col-2">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    // style={{padding:"0rem !important"}}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
    else {
      return (
        <>

          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }



  else {

    return (
      <>
        <div class="col-md-3">
          <div class="from   justify-content-between  align-items-center ">
            <label class="mr-1 mtop">{props.name.split('Per')[0]}

            </label>



          </div>
        </div>
        <div class="col-md-3 col">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default LandAnalysisD;
